var exports = {
  "z": "x1cb7f6e3--720f01--root",
  "X": "x1cb7f6e3--720f01--action",
};

module.exports = exports;
